export enum ImportDataType {
  Drivers = 1,
  Trucks = 2,
  Suppliers = 3,
  Orders = 4,
  NonMovementTransactions = 5,
}
